import React, { useState } from "react"
import { TextInput } from "../Form/TextInput"
import {
  CustomForm,
  SubmitButton,
  BackToHome,
  Request,
  SuccessMessage,
  SubText,
} from "./style"
// import gql from "graphql-tag"

// import { useMutation } from "@apollo/react-hooks"

// const CREATE_CONTACT_ENQUIRY = gql`
//   mutation CreateContactEnquiry(
//     $email: String!
//     $options: String!
//     $fullname: String!
//     $message: String!
//   ) {
//     createContactEnquiry(
//       input: {
//         clientMutationId: "CreateEnquiry"
//         email: $email
//         enquiryType: $options
//         fullName: $fullname
//         message: $message
//       }
//     ) {
//       data
//       success
//     }
//   }
// `

const options = [
  { value: "general", label: "General" },
  { value: "media-enquiry", label: "Media Enquiry" },
  { value: "careers", label: "Careers" },
]

const FormEg = () => {
  const [submitted, setSubmitted] = useState(false)
  // const [createContactEnquiry] = useMutation(CREATE_CONTACT_ENQUIRY)

  const onSubmit = values => {
    setSubmitted(true)
    // createContactEnquiry({
    //   variables: {
    //     email: values.email,
    //     options: values.options.value,
    //     fullname: values.fullname,
    //     message: values.message,
    //   },
    // })

    console.log(values)
  }
  return (
    <>
      <CustomForm submitted={submitted} noValidate onSubmit={onSubmit}>
        <Request>
          {submitted
            ? " Thanks for your message!"
            : "Please fill out the form below to get in touch."}
        </Request>

        {submitted ? (
          <SubText submitted={submitted}>
            Someone from our team will be in touch as soon as possible.{" "}
          </SubText>
        ) : (
          <SubText>
            You can also call us on <a href="">+61 2 6207 3037</a> or email us -{" "}
            <a href="">investcanberra@act.gov.au</a>
          </SubText>
        )}

        <BackToHome
          submitted={submitted}
          label="Back to the homepage"
          link="/"
        />

        <TextInput
          name="fullname"
          error="Please enter a name "
          floatingLabel="Name"
        />

        <TextInput
          type="email"
          name="email"
          error="Please enter a valid email address"
          floatingLabel="Email"
        />

        <TextInput
          type="text"
          name="phone"
          error="Please enter a phone number"
          floatingLabel="Phone number"
        />
        <TextInput
          name="message"
          type="textarea"
          error="Please enter a message"
          floatingLabel="Message"
        />
        <SubmitButton submit label="Submit message" />
      </CustomForm>
    </>
  )
}

export default FormEg
